import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpContextToken } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { MessageService } from '@services/message.service';
import { LoadingService } from '@services/loading.service';

/** Limite (MB) da soma dos arquivos de um FormData. Padrão 1 MB; só rotas de upload que o servidor
 * aceita maior (ex: salvar da vistoria com fotos) passam outro valor no HttpContext da requisição. */
export const LIMITE_ARQUIVOS_MB = new HttpContextToken<number>(() => 1);

@Injectable()
export class FileSizeInterceptor implements HttpInterceptor {

  constructor(
    private messageService: MessageService,
    private loadingService: LoadingService
  ) { }

  // no-explicit-any será desativado aqui porque o body pode ser qualquer coisa
  /* eslint-disable @typescript-eslint/no-explicit-any */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.body instanceof FormData) {
      const limiteMb = request.context.get(LIMITE_ARQUIVOS_MB);
      let totalSize = 0;
      request.body.forEach((value) => {
        if (value instanceof File) totalSize += value.size;
      });

      if (totalSize > limiteMb * 1024 * 1024) {
        this.messageService.showToastError(
          `Arquivo muito grande. O tamanho máximo permitido é ${limiteMb}MB.`
        );
        this.loadingService.setIsLoading(false);
        return throwError(() => new Error('Arquivo muito grande'));
      }
    }

    return next.handle(request);
  }
}
